<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H10C11.1046 16 12 15.1046 12 14V7H6C5.44772 7 5 6.55228 5 6V0H2Z"
    fill="currentColor"
  />
  <path
    opacity="0.5"
    d="M7 1.20711C7 0.761654 7.53857 0.538571 7.85355 0.853553L9.5 2.5L11.1464 4.14645C11.4614 4.46143 11.2383 5 10.7929 5H8C7.44772 5 7 4.55228 7 4V1.20711Z"
    fill="currentColor"
  />
</template>
